import type { Common } from '../common.js';
import type {
  BatchTestCsv,
  BatchTestPersisTestCaseResponse,
  BatchTestValidationResponse,
} from '../models/flow/batchTest/batchTest.js';
import { type ExecuteBulkResponse } from '../models/flow/flowExecution.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/batch-test';

  constructor(common: Common) {
    this.common = common;
  }

  async validate(args: {
    csv: BatchTestCsv;
    flowDefinitionId: string;
  }): Promise<BatchTestValidationResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/validate`);
    return await this.common.postJSON(url, args);
  }

  async persistTestCases(args: {
    csv: BatchTestCsv;
    flowDefinitionId: string;
  }): Promise<BatchTestPersisTestCaseResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/test-cases`);
    return await this.common.postJSON(url, args);
  }

  async execute(args: {
    csv: BatchTestCsv;
    flowDefinitionId: string;
    runGroupName: string;
    concurrentLimit?: number;
  }): Promise<ExecuteBulkResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/execute`);
    return await this.common.postJSON(url, args);
  }
}
